import {
    browserVersion,
    isAndroid,
    isBrowser,
    isChrome,
    isEdge,
    isFirefox,
    isIE,
    isOpera,
    isSafari, isSamsungBrowser
} from "react-device-detect";

export const isWhatsApp = () => {
    const userAgent = navigator.userAgent || '';

    // Detectar WhatsApp Android: "WA4A/x.xx.x" al final del user agent
    // Ejemplo: "...Mobile Safari/537.36 WA4A/2.26.2"
    // También cubre variantes como WAA, WA5A, etc.
    if (/\sWA\w*\/\d+\.\d+/i.test(userAgent)) {
        return true;
    }

    // Detectar WhatsApp iOS: "AppBundleID/net.whatsapp.WhatsApp"
    // Ejemplo: "...Mobile/15E148 AppBundleID/net.whatsapp.WhatsApp"
    if (/net\.whatsapp\.WhatsApp/i.test(userAgent)) {
        return true;
    }

    // Fallback: Detectar "WhatsApp" en el user agent (menos específico)
    // Esto cubre versiones antiguas o formatos alternativos que no coincidan arriba
    if (/WhatsApp/i.test(userAgent)) {
        return true;
    }

    return false;
};


export const checkWebVersioning = () => {
    return !(isIE || (isChrome && browserVersion < 56) || (isEdge && browserVersion < 79) || (isSafari && browserVersion < 11)
        || (isFirefox && browserVersion < 44) || (isOpera && browserVersion < 43));

}

export const checkMobileVersioning = () => {
    // WhatsApp usa WebView moderno (compatible)
    if (isWhatsApp()) {
        return true;
    }

    return !((isChrome && browserVersion < 103) || (isSafari && browserVersion < 11) || (isAndroid && browserVersion < 103)
        || (isFirefox && browserVersion < 101) || (isOpera && browserVersion < 64) || isSamsungBrowser);
}

export const isVonageCompatible = () => {
    if(isBrowser){
        return checkWebVersioning();
    }else{
        return checkMobileVersioning();
    }
}
